import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { type NewsletterConnectedToOtherFundRouteModel } from 'donor-elf-web/routes/funds/fund/more/newsletter/connected-to-other-fund';
import FundsService from 'donor-elf-web/services/funds-service';

export default class NewsletterConnectedToOtherFundController extends Controller {
  @service declare fundsService: FundsService;

  model!: NewsletterConnectedToOtherFundRouteModel;

  @action
  gotoOtherFund() {
    this.fundsService.viewFund(this.model.newsletterFund.id, {
      urlPath: 'more/newsletter',
    });
  }
}
